<template>
  <div class="row">
    <div class="col-12">
      <label for="inputSelectQueue">Filas</label>
      <div class="input-group mb-3">
        <div class="input-group-prepend">
          <span class="input-group-text" id="selectQueue">
            <i class="fas fa-users fa-fw"></i>
          </span>
        </div>
        <select
          class="form-control"
          id="inputSelectQueue"
          aria-label="Queue"
          aria-describedby="selectQueue"
          required
          v-model="selectedQueue"
          name="queue"
          ref="queue"
        >
        <!-- @change="updateTypeSelect" -->
          <option value="*">Todas</option>
          <!-- <optgroup label="Filas"> -->
            <option :key="queue.id" v-for="queue in userQueues" :value="queue.id">{{ queue.name }}</option>
          <!-- </optgroup> -->
          <!-- <optgroup label="Ilhas">
            <option :key="group.id" v-for="group in groups" :value="group.queues">{{ group.name }}</option>
          </optgroup> -->
        </select>
        <!-- <b-button v-if="typeSelect === 'groups'" class="ml-2" @click="showGroupQueues" variant="primary">
          <i class="fa-solid fa-eye"></i>
        </b-button> -->
      </div>
      <!-- <input type="hidden" name="typeSelect" :value="typeSelect">
      <input type="hidden" name="groupName" :value="selectedGroupName"> -->

      <!-- Modal -->
      <!-- <b-modal ref="groupQueuesModal" title="Filas do Grupoo" @hide="clearGroupQueues" centered>
        <ul v-if="selectedGroupQueues.length" class="list-group">
          <li v-for="(queue, index) in selectedGroupQueues" :key="index" class="list-group-item">{{ queue }}</li>
        </ul>
        <p v-else>Não há filas para este grupo.</p>
      </b-modal> -->
    </div>
  </div>
</template>


<script>
import { BModal, BButton } from 'bootstrap-vue';
import axios from 'axios';

export default {
  components: {
    BModal,
    BButton
  },
  data() {
    return {
      userQueues: [], // Filas do usuário
      allQueues: [],  // Todas as filas
      groups: [],
      selectedQueue: '*',
      typeSelect: '',
      selectedGroupName: '',
      selectedGroupQueues: []
    };
  },
  created() {
    this.getUserQueues();
    // this.getGroups();
    this.getAllQueues(); 
  },
  methods: {
    getUserQueues() {
      axios.get("/user/listQueueUser").then(response => {
        this.userQueues = response.data;
      }).catch(error => {
        console.error(error);
      });
    },
    getAllQueues() {
      axios.get("/user/listQueue").then(response => {
        this.allQueues = response.data;
      }).catch(error => {
        console.error(error);
      });
    },
    // getGroups() {
    //   axios.get("/listGroups").then(response => { 
    //     this.groups = response.data;
    //   }).catch(error => {
    //     console.error(error);
    //   });
    // },
    // updateTypeSelect() {
    //   let selectedOption = this.$refs.queue.options[this.$refs.queue.selectedIndex];
    //   let parentOptGroup = selectedOption.parentNode.label;

    //   if (parentOptGroup === 'Filas') {
    //     this.typeSelect = 'queue';
    //     this.selectedGroupName = '';
    //   } else if (parentOptGroup === 'Ilhas') {
    //     this.typeSelect = 'groups';
    //     this.selectedGroupName = selectedOption.text;
    //     this.selectedGroupQueues = this.getGroupQueues(selectedOption.value);
    //   } else {
    //     this.typeSelect = '';
    //     this.selectedGroupName = '';
    //     this.selectedGroupQueues = [];
    //   }

    //   // Emit the selected value
    //   this.$emit('selection-changed', this.selectedQueue);
    // },
    // getGroupQueues(groupQueues) {
    //   return this.allQueues.filter(queue => groupQueues.includes(queue.id)).map(queue => queue.name);
    // },
    // showGroupQueues() {
    //   this.$nextTick(() => {
    //     this.selectedGroupQueues = this.getGroupQueues(this.$refs.queue.value);
    //     this.$refs.groupQueuesModal.show();
    //   });
    // },
    // clearGroupQueues() {
    //   this.selectedGroupQueues = [];
    // }
  }
};
</script>


<style scoped>
.input-group-text {
  background-color: #007bff;
  color: #fff;
}

.b-modal {
  text-align: center;
}

.list-group-item {
  background-color: #f8f9fa;
  border: 1px solid #ddd;
}

.b-modal-header {
  background-color: #007bff;
  color: #fff;
}

.b-modal-body {
  padding: 2rem;
}

.b-modal-footer {
  display: none;
}
</style>
